export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14599.a4f34964.jpg";